<template>
  <div>
    <div>
      <v-alert
        :value="true"
        :type="this.getAlert.type"
        v-if="this.getAlert.visible"
        dismissible
      >{{this.getAlert.message | validate }}</v-alert>
      <main>
        <router-view>
          <slot></slot>
        </router-view>
      </main>
    </div>

    <v-navigation-drawer
      v-model="this.getDrawer"
      v-click-outside="outsideDrawer"
      absolute
      dark
      temporary
    >
      <div style="text-align:right;">
        <v-icon @click="insideDrawer()">close</v-icon>
      </div>

      <v-layout align-space-around justify-center column>
        <v-list>
          <v-flex xs12>
            <router-link v-for="(item, index) in overflows" :key="index" :to="item.path">
              <v-list-tile>
                <v-btn small flat @click="insideDrawer()">{{ item.title  | validate }}</v-btn>
              </v-list-tile>
            </router-link>
          </v-flex>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import router from "../router";

export default {
  name: "mainRootComponent",
  components: {
  },

  data() {
    return {
      visible: false,
      alert: true,
      drawer: null,

      overflows: [
        { title: "Home", path: "/feeds" },
        { title: "Network", path: "/network" },
        { title: "Messages", path: "/messages" },
        { title: "Notification", path: "/notifications" }
      ]
    };
  },
  computed: {
    ...mapGetters(["loaderMessage", "getDrawer", "getAlert"]),
    alertStatus() {
      if (this.loaderMessage == "") {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to.name);
      // console.log(from);
      if (
        to.name == "login" ||
        to.name == "welcome" ||
        to.name == "forgot-password" ||
        to.name == "company-profile" ||
        to.name == "add-company" ||
        to.name == "profile-two"
      ) {
        this.visible = false;
      } else {
        this.visible = true;
      }

      // react to route changes...
    }
  },
  methods: {
    showToolbar() {
      if (
        this.$route.name == "login" ||
        this.$route.name == "welcome" ||
        this.$route.name == "forgot-password" ||
        this.$route.name == "company-profile" ||
        this.$route.name == "add-company" ||
          this.$route.name == "create-password" ||
        this.$route.name == "profile-two"
      ) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    outsideDrawer() {
      this.$store.dispatch("SET_DRAWER", false);
    },
    insideDrawer() {
      this.$store.dispatch("SET_DRAWER", false);
    }
  },
  created() {
    this.showToolbar();
  }
};
</script>